import { isSpanContextValid } from '@opentelemetry/api';
import { context } from '@opentelemetry/api';
import { trace } from '@opentelemetry/api';
import pino from 'pino';

export const logger = pino({
    // disable adding time property to each log
    timestamp: false,
    // disable adding pid and hostname properties to each log
    base: {},
    // mixin tracing attributes
    mixin: () => {
        const spanContext = trace.getSpan(context.active())?.spanContext();

        if (spanContext && isSpanContextValid(spanContext)) {
            const { traceId, spanId } = spanContext;
            const traceFlags = `0${spanContext.traceFlags.toString(16)}`;
            return {
                telemetry_trace_id: traceId,
                telemetry_span_id: spanId,
                telemetry_trace_flags: traceFlags,
            };
        }

        return {};
    },
});

export default logger;
